import BaseApi from '../base/base'
import LearningStatsData from '../../models/learning_stats_data'

export interface LearningStatsDateRange {
  startDate: Date
  endDate: Date
}

export default class LearningStatsApi extends BaseApi {
  constructor() {
    super()
    this.path = '/learning_stats'
  }

  async dailySeries(dateRange: LearningStatsDateRange, courseId?: number) {
    this.path = '/learning_stats/daily_series'
    const response = await this.getRequest({ ...dateRange, courseId })
    return new LearningStatsData(response.data)
  }

  async updateManualAdjustment(date: string, courseId: number, manualAdjustmentSeconds: number) {
    this.path = '/learning_stats/manual_adjustment'
    const response = await this.patchRequest({ date, courseId, manualAdjustmentSeconds })
    return response.data
  }
}
